import React, { useEffect, useState, useRef, useCallback } from 'react';

const Stats = () => {
  const [animated, setAnimated] = useState(false);
  const statsRef = useRef(null);

  const animateCounters = useCallback(() => {
    const counters = document.querySelectorAll('.stat-number');
    counters.forEach(counter => {
      const target = parseFloat(counter.getAttribute('data-target'));
      const increment = target / 100;
      let current = 0;
      const isDecimal = target % 1 !== 0;

      const updateCounter = () => {
        current += increment;
        if (current < target) {
          counter.textContent = isDecimal ? current.toFixed(1) : Math.ceil(current).toLocaleString();
          requestAnimationFrame(updateCounter);
        } else {
          counter.textContent = isDecimal ? target.toFixed(1) : target.toLocaleString();
        }
      };

      updateCounter();
    });
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !animated) {
          setAnimated(true);
          animateCounters();
        }
      },
      { threshold: 0.5 }
    );

    const currentRef = statsRef.current;

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [animated, animateCounters]);

  return (
    <section className="stats" ref={statsRef}>
      <div className="stats-container">
        <div className="stat-item">
          <span className="stat-number" data-target="10">0</span>
          <span className="stat-label">Servers</span>
        </div>
        <div className="stat-item">
          <span className="stat-number" data-target="5000">0</span>
          <span className="stat-label">Users</span>
        </div>
        <div className="stat-item">
          <span className="stat-number" data-target="99.9">0</span>
          <span className="stat-label">Uptime %</span>
        </div>
        <div className="stat-item">
          <span className="stat-number" data-target="100">0</span>
          <span className="stat-label">Commands</span>
        </div>
      </div>
    </section>
  );
};

export default Stats;
